import UXCorePopup from './UXCorePopup';

export default UXCorePopup;
